// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"261":"e926479a","731":"d2e0b1f9","931":"903f585d"}[chunkId] + ".css";
};